import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startConferenceSessionAction } from 'store/conference/conferenceActions';
import DefaultIcon from './DefaultIcon';

export default function StartStream() {
  const dispatch = useDispatch();
  const { Status } = useSelector(({ conference }) => ({
    Status: conference.Status,
  }));
  return (
    <DefaultIcon
      name="Start"
      IconComp={PlayArrowIcon}
      hideIcon={Status !== 'OFFLINE'}
      shouldPopout={false}
      handleClick={() => {
        dispatch(startConferenceSessionAction());
      }}
    />
  );
}
